// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"85":"6118d149","124":"395be800","170":"8e2775ea","220":"1e37a468","239":"fbd17426","256":"1be3b074","334":"e564b01e","437":"edfab1b0","461":"e7c112a8","565":"804707e7","655":"99fe6f65","656":"1a3bebcd","732":"abefc605","857":"5b50d219","871":"160dcc1a","977":"157b878b"}[chunkId] + ".chunk.js";
};